import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import swal from 'sweetalert2';
import state from '@/state';
import axios from 'axios';

let lastTokenCheck = null;
const TOKEN_CHECK_INTERVAL = 30000;
let termsChecked = false;
let termsCheckPromise = null;

const router = createRouter({
    history: createWebHistory(),
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    }
});

router.beforeEach(async (to, from, next) => {
    // Define o título da página
    if (to.path === '/' || to.name === 'dashboard') {
        document.title = 'Planeta Vivo';
    } else if (to.name) {
        let routeName = to.name.charAt(0).toUpperCase() + to.name.slice(1);
        if (to.path === '/compras') {
            routeName = `${state.getters['users/get_user_data'].user_data.type_account === "junkyard" ? "Compras" : "Entradas"}`
            to.path = routeName;
        }
        document.title = `Planeta Vivo | ${routeName}`;
    } else {
        document.title = 'Planeta Vivo';
    }

    next();
});

router.beforeEach(async (to, from, next) => {
    try {
        if (to.meta.requireAdminAuth) {
            const adminData = state.getters['admin/get_admin_data'];

            if (!adminData.admin_logged || !adminData.access_token) {
                throw 'admin';
            }
        }

        if (to.meta.requireAuth) {
            const userData = state.getters['users/get_user_data'];

            if (!userData.user_logged || !userData.access_token) {
                throw 'Para acessar esta funcionalidade, faça seu login na plataforma!';
            }

            const now = Date.now();
            const shouldCheckToken = !lastTokenCheck || (now - lastTokenCheck) > TOKEN_CHECK_INTERVAL;

            if (shouldCheckToken) {
                try {
                    await axios.get(`${process.env.VUE_APP_BACKEND_URL}/meta/verify_token/clients`, {
                        headers: {
                            Authorization: `Bearer ${userData.access_token}`
                        }
                    });
                    lastTokenCheck = now;
                } catch (error) {
                    lastTokenCheck = null;
                    state.dispatch('users/logout');
                    throw 'Sua sessão expirou. Por favor, faça login novamente.';
                }
            }

            if (!termsChecked) {
                if (!termsCheckPromise) {
                    termsCheckPromise = (async () => {
                        try {
                            const termsResult = await state.dispatch('meta/fetchTermsStatus');

                            if (!termsResult?.data?.terms_accepted) {
                                await new swal({
                                    title: 'Termos de Uso e Política de Privacidade',
                                    html: 'Para continuar usando o Planeta Vivo, é preciso ler e aceitar os <a href="/terms-of-use" target="_blank" rel="noopener">Termos de Uso</a> e a <a href="/privacy-policy" target="_blank" rel="noopener">Política de Privacidade</a>.',
                                    icon: 'info',
                                    confirmButtonText: 'Aceito',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    showCancelButton: false,
                                    showCloseButton: false,
                                    customClass: {
                                        confirmButton: 'btn btn-primary'
                                    },
                                    buttonsStyling: false
                                });

                                try {
                                    await state.dispatch('meta/acceptTerms');
                                } catch (acceptError) {
                                    await new swal({
                                        title: 'Não foi possível confirmar',
                                        text: 'Não conseguimos registrar seu aceite dos termos. Tente navegar novamente.',
                                        icon: 'error',
                                        confirmButtonText: 'OK',
                                        customClass: {
                                            confirmButton: 'btn btn-primary'
                                        },
                                        buttonsStyling: false
                                    });
                                    throw acceptError;
                                }
                            }

                            termsChecked = true;
                        } catch (termsError) {
                            // erro ao checar/confirmar termos não deve travar a navegação;
                            // termsChecked continua false, então a checagem é refeita na próxima navegação
                        } finally {
                            termsCheckPromise = null;
                        }
                    })();
                }

                await termsCheckPromise;
            }
        }

        next();
    } catch (issue) {
        if (issue === 'admin') {
            await new swal({
                title: 'Acesso Restrito',
                text: 'Você precisa estar autenticado como administrador',
                icon: 'warning',
                confirmButtonText: 'Login Admin',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false
            });
            return next({ name: 'admin-login' });
        }

        await new swal({
            title: 'Acesso Restrito',
            text: issue,
            icon: 'warning',
            confirmButtonText: 'Fazer Login',
            customClass: {
                confirmButton: 'btn btn-primary'
            },
            buttonsStyling: false
        });

        next({ name: 'login' });
    }
});

export default router;